module.exports = __webpack_public_path__ + "static/media/Helping Others (Expressing Limits) V034.es.3a2d560d.vtt";